
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Home, ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md border-blue-100 shadow-lg">
        <CardHeader className="text-center">
          <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-lg flex items-center justify-center mx-auto mb-4">
            <Home className="h-8 w-8 text-white" />
          </div>
          <CardTitle className="text-4xl font-bold text-gray-900 mb-2">404</CardTitle>
          <CardDescription className="text-xl text-gray-600">
            Oops! Page not found
          </CardDescription>
        </CardHeader>
        
        <CardContent className="text-center space-y-4">
          <p className="text-gray-600">
            The page you're looking for doesn't exist or has been moved.
          </p>
          
          <div className="flex flex-col space-y-2">
            <Button asChild className="bg-blue-600 hover:bg-blue-700">
              <Link to="/">
                <Home className="h-4 w-4 mr-2" />
                Go Home
              </Link>
            </Button>
            
            <Button asChild variant="outline" className="border-blue-300 text-blue-600 hover:bg-blue-50">
              <Link to="/login">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Go to Login
              </Link>
            </Button>
          </div>
          
          <div className="mt-6 text-xs text-gray-500">
            <p>Path attempted: <code className="bg-gray-100 px-2 py-1 rounded">{location.pathname}</code></p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFound;
